var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartingPointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.5 19.794l9-5.196c2-1.155 2-4.041 0-5.196l-9-5.196c-2-1.155-4.5.288-4.5 2.598v10.392c0 2.31 2.5 3.753 4.5 2.598M21 19a1 1 0 1 1-2 0V5a1 1 0 1 1 2 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartingPointIcon);
export default __webpack_public_path__ + "static/media/starting_point_icon.1a9f274f72849ff659f4d0876b592fe5.svg";
export { ForwardRef as ReactComponent };